import { forwardRef, useEffect, useRef, useState } from 'react'
import { BackButton, Body, Box, H3, ToggleButtons } from '../widgets'
import './TwoColumnView.scss'

export const TwoColumnView = forwardRef(function TwoColumnView ({ title, startingColumn = 0, column1, column1Label, column2, column2Label, displayMode, onClose, className, refButtonIndex, ...props }, ref) {
  const container = useRef()
  const getSelectedButton = () => Math.max(Math.min(Math.floor(container.current?.scrollLeft / (container.current?.scrollWidth / 4)), 1), 0)
  const [selectedButton, setSelectedButton] = useState(startingColumn)

  const itemRefs = useRef(Array.from({ length: 2 }))

  useEffect(() => {
    container.current.scrollTo({
      left: startingColumn === 1 ? container.current.scrollWidth : 0,
      behavior: 'smooth'
    })
  }, [startingColumn])

  useEffect(() => {
    const element = container.current
    const updateValue = () => setSelectedButton(getSelectedButton())
    element.addEventListener('scroll', updateValue)
    return () => element.removeEventListener('scroll', updateValue)
  }, [])

  const showColumn = index => container.current.scrollTo({ left: container.current.scrollWidth * index, behavior: 'smooth' })

  const checkCenter = () => {
    if(window.innerWidth < 600) {
      const viewportMiddle = window.innerWidth / 2
      itemRefs.current.forEach((ref, index) => {
        if(ref) {
          const rect = ref.getBoundingClientRect();
          const elementMiddle = rect.left + rect.width / 2

          const threshold = window.innerWidth / 1.75 // pixels of tolerance

          if (Math.abs(viewportMiddle - elementMiddle) < threshold) {
            showColumn(index)
          }
        }
      })
    }
  }

  return (
    <Box
      column
      fullHeight
      fullWidth
      background="black"
      zIndex={20}
      className={`two-column-view hide-scrollbars${className ? ` ${className}` : ''}`}
      {...props}
    >
      {!displayMode && <BackButton onClick={onClose} />}

      <H3 style={{ alignSelf: 'center', padding: '0 20px' }}>
        {title}
      </H3>

      <Box column fullWidth className="mobile-only" px={20} gap={8}>
        <Body fullWidth align="center">Scroll left and right to compare</Body>
        <ToggleButtons
          value={selectedButton}
          labels={[column1Label, column2Label]}
          onChange={showColumn}
          ref={ref}
          refButtonIndex={refButtonIndex}
        />
      </Box>

      <Box
        fullWidth
        gap={40}
        className="view-columns-contains"
        ref={container}
        onMouseUp={checkCenter}
        onTouchEnd={checkCenter}
      >
        <Box className="view-column" ref={card => itemRefs.current[0] = card} id="0-column">
          <Box column gap={16} maxWidth={700}>
            {column1}
          </Box>
        </Box>
        <Box className="view-column" ref={card => itemRefs.current[1] = card} id="1-column">
          <Box column gap={16} maxWidth={700}>
            {column2}
          </Box>
        </Box>
      </Box>
    </Box>
  )
})
